import React from "react";
import { useNavigate } from "react-router-dom";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import usStates from "../data/us-states.json";

const HomePage = () => {
    const navigate = useNavigate();

    // This function is called for each state (GeoJSON feature)
    const onEachState = (feature, layer) => {
        // Using Popup on mouseover and mouseout. See alternative below.
        layer.bindPopup(feature.properties.name);
        // On hover, change the fill color.
        layer.on({
            mouseover: e => {
                e.target.setStyle({
                    fillColor: "blue",
                });
                e.target.openPopup();
            },
            mouseout: e => {
                e.target.setStyle({
                    fillColor: "aquamarine",
                });
                e.target.closePopup();
            },
            click: () => {
                // Navigate to the state-specific page using the state name
                navigate(`/state/${feature.properties.name}`);
            },
        });
        // Bind a popup with the state name.
        layer.bindPopup(feature.properties.name);
    };

    return (
        <div>
            <h1>Breweries in the United States</h1>
            <MapContainer
                style={{ height: "80vh", width: "100%" }}
                center={[37.8, -96]}
                zoom={4}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                <GeoJSON
                    data={usStates}
                    onEachFeature={onEachState}
                    style={{ fillColor: "aquamarine", weight: 1, color: "blue" }}
                />
            </MapContainer>
        </div>
    );
};

export default HomePage;



// ALTERNATIVE VERSION using Tooltip instead of Popup

// const onEachState = (feature, layer) => {
//     layer.bindTooltip(feature.properties.name, { sticky: true });
//     layer.on({
//         mouseover: e => {
//             e.target.setStyle({
//                 fillColor: "blue",
//             });
//         },
//         mouseout: e => {
//             e.target.setStyle({
//                 fillColor: "aquamarine",
//             });
//         },
//         click: () => {
//             // Navigate to the state-specific page using the state name
//             navigate(`/state/${feature.properties.name}`);
//         },
//     });
//     // Bind a popup with the state name.
//     layer.bindPopup(feature.properties.name);
// };
